/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  RatingRef,
  RatingRefOptional,
  RatingRefMetaI,
  RatingRefTrackedI,
} from "./rating-ref";
import { RatingRefTracked, RatingRefMeta } from "./rating-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithRatingName,
  WithRatingNameOptional,
  WithRatingNameMetaI,
  WithRatingNameTrackedI,
} from "./with-rating-name";
import { WithRatingNameTracked, WithRatingNameMeta } from "./with-rating-name";

/**
 *
 * @export
 * @interface RatingRefAndName
 */
export interface RatingRefAndNameOptional extends RatingRefOptional {
  /**
   *
   * @type {number}
   * @memberof RatingRefAndName
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof RatingRefAndName
   */
  ratingName?: string;
}

export interface RatingRefAndName
  extends RatingRefAndNameOptional, RatingRef, WithRatingName {
  /**
   *
   * @type {number}
   * @memberof RatingRefAndName
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof RatingRefAndName
   */
  ratingName?: string;
}

export interface RatingRefAndNameTrackedI extends RatingRefOptional {
  /**
   *
   * @type {number}
   * @memberof RatingRefAndName
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof RatingRefAndName
   */
  ratingName?: string;
  ratingNameIsSet: boolean;
}

transformDatesMap.set(
  "RatingRefAndName",
  function (model: RatingRefAndName) {},
);

export type RatingRefAndNameMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  ratingName: PropertyMeta<MetaTypeBase<string>>;
}>;

export var RatingRefAndNameMeta: RatingRefAndNameMetaI =
  {} as RatingRefAndNameMetaI;
RatingRefAndNameMeta = typeMeta("RatingRefAndName", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  ratingName: propertyMeta(
    "ratingName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = RatingRefAndNameMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([RatingRefMeta]);
  metaI.assignId.inheritedFrom = RatingRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([WithRatingNameMeta]);
  metaI.ratingName.inheritedFrom = WithRatingNameMeta.ratingName;
});

export class RatingRefAndNameTracked
  extends RatingRefTracked
  implements RatingRefAndNameTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  ratingName__I?: string = undefined;
  ratingNameIsSet: boolean = false;
  set ratingName(v: undefined | string) {
    if (v !== undefined) {
      this.ratingName__I = v;
      this.ratingNameIsSet = true;
    } else {
      this.ratingName__I = v || undefined;
      this.ratingNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingName() {
    return this.ratingName__I;
  }
  constructor(config?: RatingRefAndNameOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: RatingRefAndNameOptional,
    options?: AssignOptions,
  ): RatingRefAndNameTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.ratingName &&
      this.ratingNameApplyFilter(optionsRequired.filter)
    ) {
      this.ratingName = config.ratingName;
      if (optionsRequired.unassign) this.ratingNameIsSet = false;
      else this.ratingNameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): RatingRefAndNameTrackedI {
    const cloned = {} as RatingRefAndNameTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.ratingNameIsSetDeep() &&
      this.ratingNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingNameIsSet = true;
      cloned.ratingName = this.ratingName;
    } else {
      //cloned.ratingNameIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): RatingRefAndNameTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.ratingNameApplyFilter(filter)) this.ratingNameIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingRefAndNameMeta.assignId,
      RatingRefAndNameMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  ratingNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingRefAndNameMeta.ratingName,
      RatingRefAndNameMeta,
      this.ratingName,
      this,
    );
  }
  ratingNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ratingNameIsSet && this.ratingNameApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.ratingNameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
